var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7732 4V4.01602V5.61843C16.2904 6.05108 18.7822 9.24787 18.3495 12.7651C17.981 15.6815 15.6895 17.997 12.7732 18.3415V19.9439C17.1798 19.5033 20.3846 15.5934 19.9439 11.1868C19.5834 7.38107 16.5628 4.37656 12.7732 4ZM11.1708 4.02404C9.60841 4.17626 8.11818 4.77717 6.90035 5.78668L8.04607 6.97246C8.94341 6.25138 10.025 5.78668 11.1708 5.62644V4.02404ZM5.77066 6.91637C4.76114 8.1342 4.16024 9.61642 4 11.1868H5.6024C5.75463 10.0491 6.2033 8.96745 6.91637 8.06209L5.77066 6.91637ZM14.7762 9.18378L10.8663 13.0936L9.16775 11.3951L8.31848 12.2444L10.8663 14.7922L15.6254 10.0331L14.7762 9.18378ZM4.00801 12.7892C4.16825 14.3595 4.78518 15.8418 5.77867 17.0596L6.91637 15.9139C6.21132 15.0085 5.75463 13.9269 5.61042 12.7892H4.00801ZM8.04607 17.0916L6.90035 18.1893C8.11016 19.1988 9.6004 19.8317 11.1708 20V18.3976C10.033 18.2534 8.95143 17.7967 8.04607 17.0916Z",
    fill: "#9FA3AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyIcon);
export default __webpack_public_path__ + "static/media/GreyIcon.53427f403e33c1128e1a999ca3107a98.svg";
export { ForwardRef as ReactComponent };